import Axios from 'axios';
import { useInfiniteQuery } from '@tanstack/vue-query';
import useUrlFilters from './useUrlFilters';
import useUrlParams from '../../../composables/useUrlParams';

export default function useProductList(paginator, filters, sorts, productList = null) {
  const { getQueryParamFilter, getQueryParamFilterSort } = useUrlFilters();
  const params = useUrlParams();
  const isSearchPage = !productList;

  return useInfiniteQuery({
    queryKey: ['productListItems'],
    queryFn: () => Axios.get(`${isSearchPage ? '/api/search' : `/api/product-lists/${productList?.id}`}`, {
      params: {
        filters: getQueryParamFilter() || null, sorts: getQueryParamFilterSort() || null, page: params.page || null, query: params.query || null,
      },
    }),
    getNextPageParam: (lastPage) => (lastPage.data.paginator.current_page < lastPage.data.paginator.last_page
      ? lastPage.data.paginator.current_page + 1
      : null),
    getPreviousPageParam: (lastPage) => (lastPage.data.paginator.current_page > 1
      ? lastPage.data.paginator.current_page - 1
      : null),
    placeholderData: (previousData) => (previousData || {
      pageParams: [{ pageParams: paginator.current_page }],
      pages: [{ data: { paginator, filters, sorts } }],
    }),
    refetchOnWindowFocus: false,
  });
}
